import React from 'react';
import AsyncAddRequest from './addrequest/async';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';

const parent2 = {
  title: <Trans i18nKey="p.contactus.parent.title">Home</Trans>,
  path: '/',
};
export default [
  <SingleColumnLayout
    exact
    key="b"
    className="kt-portlet--solid-gray"
    path="/contactus/add-request"
    component={AsyncAddRequest}
    title={<Trans i18nKey="p.contactus.title">Contact Us</Trans>}
    parents={[parent2]}
  />,
  <Redirect key="e" exact from="/contactus" to="contactus/add-request" />,
];
